import { render, staticRenderFns } from "./HomeSecondary.vue?vue&type=template&id=00d8d857&scoped=true&"
import script from "./HomeSecondary.vue?vue&type=script&lang=js&"
export * from "./HomeSecondary.vue?vue&type=script&lang=js&"
import style0 from "./HomeSecondary.vue?vue&type=style&index=0&id=00d8d857&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d8d857",
  null
  
)

export default component.exports